import { resolveComponentName } from '~/logic/cms/resolveComponentName'

export function getCmsElementComponentName(content: { type: string }) {
  return resolveComponentName('elements', content.type)
}
